function getCssVar(varName) {
    return getComputedStyle(document.documentElement).getPropertyValue(varName);
}
function getBreakpoint(name) {
    const val = getCssVar(`--breakpoint-${name}`).replace('px', '');
    return parseInt(val, 10);
}
function ready(func) {
    if (document.readyState !== 'loading') {
        return func(new Event('ready'));
    }
    document.addEventListener('DOMContentLoaded', func);
}
function withEl(selector, func, options = {}) {
    let roots = [document.body];
    if (options.root) {
        roots =
            typeof options.root == 'string'
                ? Array.from(document.querySelectorAll(options.root))
                : [options.root];
    }
    const els = typeof selector == 'object'
        ? [selector]
        : roots.flatMap((root) => Array.from(root.querySelectorAll(selector)));
    if (options.ready !== true) {
        els.forEach(func);
        return;
    }
    return ready(() => {
        els.forEach(func);
    });
}
function setListener(selector, event, func, options = {}) {
    withEl(selector, (el) => {
        el.addEventListener(event, (e) => {
            if (options.prevent) {
                e.preventDefault();
            }
            func(e, el);
        }, options);
    }, options);
}
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function omitEnumKeys(list, ...keys) {
    const entries = Object.entries(list);
    return Object.fromEntries(entries.filter(([k, _]) => !keys.includes(k, _)));
}
export { getBreakpoint, omitEnumKeys, ready, setListener, sleep, withEl };
